import React, { useState, useEffect } from 'react'
import { Table, Image, OverlayTrigger, Button, FormControl } from 'react-bootstrap'
import NewArticle from './NewArticle'
import DetailedArticleType from './DetailedArticleType'
import '../../index.css'
import { connect, useSelector } from 'react-redux'

import { addArticleType, updateArticleType } from '../../store/actions/index'
import { FetchCreateArticle, FetchArticleTypes, FetchUpdateArticle, FetchArticleTypeImages } from '../../fetcher'
import { ModalComponent } from '../presentational-components/ModalComponent'
import AlertMessage from '../presentational-components/AlertMessage'
import { RenderImage } from '../presentational-components/ImageViewer'

const ArticleTypeView = ({ dispatch, newArticleType, updatedArticleType }) => {
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const [showArticle, setShowArticle] = useState(false);
    const handleCloseArticle = () => setShowArticle(false);
    const handleShowArticle = () => setShowArticle(true);

    const [articleDetail, setArticle] = useState([])
    const [sizeCat, setSizeCat] = useState()

    const openModal = (e) => {
        handleShowModal()
    }

    const openArticleType = (article) => (e) => {
        e.preventDefault()

        setSizeCat(article.SizeAttribute.SizeCategory)
        setArticle(article)
        handleShowArticle()
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [articleData, setArticleData] = useState([]);
    const [articleDataReady, setArticleDataToReady] = useState(false)

    const addingImages = (articleTypeImages) => {
        let copiedArticleData = [...articleData]
        articleTypeImages.forEach(image => copiedArticleData.find(x => x.ArticleTypeSysId == image.ArticleTypeSysId).Image = 'data:image/png;base64,' + image.Data)
        //console.log(articleTypeImages[0])
        //console.log(articleTypeImages.map(x => x.ArticleTypeSysId))
        //console.log(copiedArticleData.map(x => x.ArticleTypeSysId))
        setArticleData(copiedArticleData)
    }

    useEffect(() => {
        FetchArticleTypes(setArticleData, openAlert, setArticleDataToReady)
    }, [])
    
    useEffect(() => {
        if (articleDataReady) {
            //FetchArticleTypeImages(articleData.map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert)
            //articleData.forEach(x => FetchArticleTypeImages(x.ArticleTypeSysId, addingImages, openAlert))
            FetchArticleTypeImages(articleData.map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    const reload = () => {
        setArticleDataToReady(false)
        FetchArticleTypes(setArticleData, openAlert, setArticleDataToReady)
    }

    const [filterable, setFilterable] = useState(false)
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    const [selectFilterInput, setSelectFilterInput] = useState("")
    const selectFilteredElements = (e) => {
        setSelectFilterInput(e.target.value)
    }

    const [selectFilterInput2, setSelectFilterInput2] = useState("")
    const selectFilteredElements2 = (e) => {
        setSelectFilterInput2(e.target.value)
    }

    const StatusSelect = () => {
        return (
            <FormControl className="filterForm" defaultValue={selectFilterInput} as="select" size="sm" onChange={selectFilteredElements}>
                <option>All</option>
                {[...new Set(articleData.map(x => x.SizeAttribute.SizeCategory))].map(x => <option>{x}</option>)}
            </FormControl>
        )
    }

    const StatusSelect2 = () => {
        return (
            <FormControl className="filterForm" defaultValue={selectFilterInput2} as="select" size="sm" onChange={selectFilteredElements2}>
                <option>---</option>
                {[...new Set(articleData.map(x => x.Sexes))].map(x => <option>{x}</option>)}
            </FormControl>
        )
    }

    const sortColumn = (id, order) => (e) => {
        e.preventDefault()
        if (id == 1) {
            if (order == "desc") {
                console.log(articleData)

                let sortedData = [...articleData]
                sortedData.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                })

                //articleData.sort(function (a, b) {
                //    // localeCompare does a string comparison that returns -1, 0, or 1
                //    return a.Name.localeCompare(b.Name);
                //});

                console.log(articleData)
            }
            if (order == "asc")
                articleData.sort((a, b) => (a.Name > b.Name) ? 1 : -1)
        }
        if (id == 2) {
            if (order == "desc")
                articleData.sort((a, b) => (a.ArticleNumberDesigner > b.ArticleNumberDesigner) ? -1 : 1)
            if (order == "asc")
                articleData.sort((a, b) => (a.ArticleNumberDesigner > b.ArticleNumberDesigner) ? 1 : -1)
        }
        if (id == 3) {
            if (order == "desc")
                articleData.sort((a, b) => (a.Price > b.Price) ? -1 : 1)
            if (order == "asc")
                articleData.sort((a, b) => (a.Price > b.Price) ? 1 : -1)
        }
    }

    const [filterInput, setFilterInput] = useState("")

    const handleInput = (e) => {
        setFilterInput(e.target.value)
    }

    const filteredElements = () => {
        let filteredItems = articleData
        if (filterInput.trim() != "") {
            filteredItems = filteredItems.filter(x => JSON.stringify(x).toString().toLowerCase().includes(filterInput.toLowerCase()))
        }
        if (selectFilterInput != "All" && selectFilterInput != "") {
            filteredItems = filteredItems.filter(x => x.SizeAttribute.SizeCategory == selectFilterInput)
        }
        if (selectFilterInput2 != "---" && selectFilterInput2 != "") {
            filteredItems = filteredItems.filter(x => x.Sexes == selectFilterInput2)
        }

        return (
            filteredItems.map(entry =>
                <tr>
                    <td>{RenderImage(entry.Image)}</td>
                    <td className="mainColumn"><a onClick={openArticleType(entry)} href=''>{entry.Name}</a></td>
                    <td id="2" className="mainColumn">{entry.ArticleNumberDesigner}</td>
                    <td className="mainColumn">{entry.SizeAttribute.SizeCategory}</td>
                    <td className="mainColumn">{entry.Sexes}</td>
                    <td className="td_number mainColumn" >{parseFloat(entry.Price).toFixed(2).replace('.', ',')}</td>
                    <td className="mainColumn">{entry.DescriptionDesigner}</td>
                    <td></td>
                </tr>)
        )
    }

    return (
        <div lang="de">
            <h1>Artikeltypen</h1>
            
            <Button variant="secondary" className="form" onClick={openModal}>Neuen Artikeltypen hinzufügen</Button>

            <FormControl className="globalSearch" as="input" placeholder="Suche..." onChange={handleInput}></FormControl>
            <Table className='table table-striped' aria-labelledby="tabelLabel" size="sm">
                <thead>
                    <tr>
                        <th>Ansicht</th>
                        <th className="mainColumn">Name
                            <a href="" className="sort-link" onClick={sortColumn(1, "desc")}>&#8593;</a>
                            <a href="" className="sort-link" onClick={sortColumn(1, "asc")}>&#8595;</a>
                        </th>
                        <th className="mainColumn">Artikelnummer
                            <a href="" className="sort-link" onClick={sortColumn(2, "desc")}>&#8593;</a>
                            <a href="" className="sort-link" onClick={sortColumn(2, "asc")}>&#8595;</a>
                        </th>
                        <th className="mainColumn">Größenkategorie</th>
                        <th className="mainColumn">Geschlecht</th>
                        <th className="mainColumn">Preis in €
                            <a href="" className="sort-link" onClick={sortColumn(3, "desc")}>&#8593;</a>
                            <a href="" className="sort-link" onClick={sortColumn(3, "asc")}>&#8595;</a>
                        </th>
                        <th className="mainColumn">Beschreibung</th>
                        <th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>
                    </tr>
                </thead>
                {filterable ? <thead>
                    <th></th><th></th><th></th>
                    <th>{StatusSelect()}</th>
                    <th>{StatusSelect2()}</th>
                    <th></th><th></th>
                </thead> : null}
                <tbody>
                    {filteredElements()}
                </tbody>
            </Table>

            <ModalComponent handleShow={showModal} handleClose={handleCloseModal} reload={reload}
                modalTitle="Neuen Artikeltypen hinzufügen" modalBody={<NewArticle handleCloseModal={handleCloseModal} openAlert={openAlert} />} formTitle="create-article-form" />

            <ModalComponent handleShow={showArticle} handleClose={handleCloseArticle} reload={reload}
                modalTitle={"Artikeltyp bearbeiten: '" + articleDetail.Name + "'"}
                modalBody={<DetailedArticleType sizeCat={sizeCat} articleDetail={articleDetail} handleCloseArticle={handleCloseArticle} openAlert={openAlert} />} formTitle="update-article-form" />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

const testing = (prop) => {
    return prop
}

const mapStateToProps = (state) => ({
    newArticleType: state.newArticleType[0],
    updatedArticleType: state.updatedArticleType[0],
})

export default connect(mapStateToProps)(ArticleTypeView)